module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[66]65.2f5597c.woff2";